import checkmateApi from "../axios/checkmateApi"
import { ITeam, ITeamConfig } from "../slices/teamSlice";

export const getTeamList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'teams'
    });
    return response;
}

export const getTeamTypeList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'teams/types'
    });
    return response;
}

export const getDatasourceList = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: 'datasources'
    });
    return response;
}

export const getTeamDetails = async (teamId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `teams/${teamId}?fields=users`
    });
    return response;
}

export const getTeamConfigByTeamId = async (teamId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `teamconfs/team/${teamId}`
    });
    return response;
}

export const getTeamConfigAndTeamDetails = async (teamId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `teams/${teamId}/detail`
    });
    return response;
}

export const createTeam = async (team: ITeam) => {
    const response = checkmateApi({
        method: 'POST',
        url: 'teams',
        data: team
    });
    return response;
}

export const createTeamConfig = async (config: ITeamConfig) => {
    const response = checkmateApi({
        method: 'POST',
        url: 'teamconfs',
        data: config
    });
    return response;
}

export const updateTeam = async (team: ITeam) => {
    const response = checkmateApi({
        method: 'PUT',
        url: 'teams',
        data: team
    });
    return response;
}

export const updateTeamConfig = async (config: ITeamConfig) => {
    const response = checkmateApi({
        method: 'PUT',
        url: `teamconfs/${config.id}`,
        data: config
    });
    return response;
}

export const deleteTeam = async (teamId: string) => {
    const response = checkmateApi({
        method: 'DELETE',
        url: `teams/${teamId}`
    });
    return response;
}